module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_7005.fde45737.png";